module.exports = __webpack_public_path__ + "img/Jump Casting115.69bfe6e4.jpg";